import * as React from 'react';

import { DeviceInfoContext } from '@/contexts/device-info-context';

function TransactionsIcon(props) {
  const { isMobile } = React.useContext(DeviceInfoContext);

  return isMobile ? (
    <svg width={30} height={42} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g filter='url(#prefix__filter0_bi_211_1045)'>
        <path
          d='M19.278 4.844V1.601c0-.324-.128-.649-.38-.897a1.31 1.31 0 00-.92-.37 1.31 1.31 0 00-.917.37L8.889 8.572l8.172 7.867c.253.248.585.372.918.372.332 0 .665-.124.918-.372.253-.247.38-.572.38-.896V12.39c3.572.086 7.474.717 10.39 5.056v-1.268c0-5.872-4.546-10.701-10.39-11.333z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M15 33c6.627 0 12-5.373 12-12S21.627 9 15 9 3 14.373 3 21s5.373 12 12 12z'
        fill='url(#prefix__paint0_linear_211_1045)'
      />
      <path
        d='M10.333 15.5c0-.276.299-.5.667-.5h8c.368 0 .666.224.666.5v1c0 .276-.298.5-.666.5h-8c-.368 0-.667-.224-.667-.5v-1zM10.333 18.833c0-.276.299-.5.667-.5h8c.368 0 .666.224.666.5v1c0 .277-.298.5-.666.5h-8c-.368 0-.667-.223-.667-.5v-1z'
        fill='#fff'
      />
      <path
        d='M15.666 18.333c.369 0 .667.256.667.572v6.857c0 .316-.298.571-.667.571h-1.333c-.368 0-.667-.255-.667-.571v-6.857c0-.316.299-.572.667-.572h1.333z'
        fill='#fff'
      />
      <g filter='url(#prefix__filter1_bi_211_1045)'>
        <path
          d='M11.027 37.302V40.6c0 .33.131.66.392.913.26.251.603.376.945.376.342 0 .684-.125.945-.376l8.413-8.002-8.413-8a1.359 1.359 0 00-.945-.378c-.342 0-.684.126-.945.377-.26.252-.392.583-.392.912v3.208c-3.676-.088-7.693-.73-10.694-5.142v1.289c0 5.972 4.679 10.883 10.694 11.525z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <filter
          id='prefix__filter0_bi_211_1045'
          x={4.889}
          y={-3.667}
          width={28.777}
          height={25.111}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1045' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1045' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_1045' />
        </filter>
        <filter
          id='prefix__filter1_bi_211_1045'
          x={-3.667}
          y={20.488}
          width={29.389}
          height={25.401}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1045' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1045' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_1045' />
        </filter>
        <linearGradient
          id='prefix__paint0_linear_211_1045'
          x1={3}
          y1={9}
          x2={23.928}
          y2={6.567}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg width={44} height={63} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g filter='url(#prefix__filter0_bi_159_3125)'>
        <path
          d='M28.416 6.766V1.901c0-.486-.19-.973-.57-1.346A1.965 1.965 0 0026.468 0c-.498 0-.997.184-1.377.555L12.833 12.358l12.258 11.801c.38.37.879.557 1.377.557.5 0 .998-.186 1.378-.557.38-.37.57-.86.57-1.344v-4.732c5.357.129 11.21 1.076 15.584 7.584v-1.902c0-8.808-6.818-16.052-15.584-16.999z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M22 49c9.941 0 18-8.059 18-18s-8.059-18-18-18S4 21.059 4 31s8.059 18 18 18z'
        fill='url(#prefix__paint0_linear_159_3125)'
      />
      <path
        d='M15 22.75c0-.414.448-.75 1-.75h12c.552 0 1 .336 1 .75v1.5c0 .414-.448.75-1 .75H16c-.552 0-1-.336-1-.75v-1.5zM15 27.75c0-.414.448-.75 1-.75h12c.552 0 1 .336 1 .75v1.5c0 .414-.448.75-1 .75H16c-.552 0-1-.336-1-.75v-1.5z'
        fill='#fff'
      />
      <path
        d='M23 27c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857h-2c-.552 0-1-.384-1-.857V27.857c0-.473.448-.857 1-.857h2z'
        fill='#fff'
      />
      <g filter='url(#prefix__filter1_bi_159_3125)'>
        <path
          d='M16.041 55.452V60.4c0 .495.197.99.588 1.369.39.377.904.565 1.418.565.513 0 1.026-.188 1.417-.565l12.619-12.003-12.619-12.001a2.038 2.038 0 00-1.417-.566c-.514 0-1.027.189-1.418.566a1.897 1.897 0 00-.588 1.367v4.812C10.527 43.813 4.501 42.85 0 36.232v1.933C0 47.123 7.018 54.49 16.04 55.452z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <filter
          id='prefix__filter0_bi_159_3125'
          x={8.833}
          y={-4}
          width={39.167}
          height={33.666}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_159_3125' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_159_3125' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_159_3125' />
        </filter>
        <filter
          id='prefix__filter1_bi_159_3125'
          x={-4}
          y={32.232}
          width={40.083}
          height={34.102}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_159_3125' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_159_3125' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_159_3125' />
        </filter>
        <linearGradient
          id='prefix__paint0_linear_159_3125'
          x1={4}
          y1={13}
          x2={35.391}
          y2={9.351}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default TransactionsIcon;
